import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Modal,
  Box,
  Chip,
  Container,
} from "@mui/material";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import React, { useState, useContext } from "react";
import PopupCard from "../popup_card/popupCard.js";
import FilterCard from "../popup_card/XLFilterCard.js";
import TemplateFilterCard from "../popup_card/TemplateFilterCard.js";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import style from "./TransactionsTable.module.css";
import ModalForm from "../forms/MainForm.js";
import { useQuery } from "@tanstack/react-query";
import { DataContext } from "../../context/dataprovider.js";
import Loader from "../../loader/loader.js";
import apiClient from "../../api/Api.js";
import formatDate from "../../utils/formateDate.js";
import TransactionsFilter from "../Filters/Transactions/TransactionsFilter.js";
import StorageIcon from "@mui/icons-material/Storage";
import Statuscard from "../popup_card/statuscard.js";
import DownloadIcon from "@mui/icons-material/Download";
import {
  calculateNetPayable,
  getPendingAmount as calculatePendingAmount,
} from "../../utils/paymentAmounts.js";

const TRANSACTIONS_API = process.env.REACT_APP_TRANSACTIONS_API;
const STATUS_API = process.env.REACT_APP_UPDATE_STATUS;
const statusDef = {
  initial: "Submitted",
  phase1: "Approved",
  phase2: "Financial Approved",
  phase3: "Uploaded to Bank",
  phase4: "Payment done,Awaiting for Bills",
  phase5: "Bills Quality Hold",
  final: "Bills Accepted",
  fail: "Denied",
  accountantDenied: "Accountant Denied",
  financialDenied: "Financial Admin Denied",
  qualityfail: "Bills Quality failed",
  Suspend: "Suspended",
  partialPayment: "Partial Payment Done",
};

// Statuses where full payment has been completed
const FULLY_PAID_STATUSES = [
  "Payment done,Awaiting for Bills",
  "Bills Quality Hold",
  "Bills Accepted",
  "Bills Quality failed",
];

// Safely compute pending amount — handles legacy records where paidamount=0 but payment was done
const getPendingAmount = (transaction) => {
  void FULLY_PAID_STATUSES;
  return calculatePendingAmount(transaction);
};

function TransactionsTable() {
  const {
    userData = {},
    statusColors = {},
    role = {},
  } = useContext(DataContext);
  // console.log(`user Data in Home ${JSON.stringify(userData)}`);

  const [openPopup, setOpenPopup] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openstatusPopup, setOpenstatusPopup] = useState(false);
  const [filters, setFilters] = useState({
    senderName: null,
    status: null,
    fromDate: null,
    toDate: null,
    transId: null,
    projectId: null,
    payment_type: null,
    vendorname: null,
  });
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [statusdata, setStatusData] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [totalpages, setTotalPages] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null); // 'xl' or 'pr'

  const handleOpenModal = (option) => {
    setSelectedOption(option);
    setOpenFilterModal(true);
  };

  const getStatusColor = (currentStatus) => {
    switch (currentStatus) {
      case statusDef.initial:
        return statusColors.initial;
      case statusDef.phase1:
        return statusColors.phase1;
      case statusDef.phase2:
        return statusColors.phase2;
      case statusDef.phase3:
        return statusColors.phase3;
      case statusDef.phase4:
        return statusColors.phase4;
      case statusDef.phase5:
        return statusColors.phase5;
      case statusDef.partialPayment:
        return statusColors.partialPayment;
      case statusDef.final:
        return statusColors.final;
      case statusDef.fail:
        return statusColors.fail;
      case statusDef.accountantDenied:
        return statusColors.accountantDenied;
      case statusDef.financialDenied:
        return statusColors.financialDenied;
      case statusDef.qualityfail:
        return statusColors.qualityfail;
      case statusDef.Suspend:
        return statusColors.suspend;
      default:
        return "#D32F2F"; // Default Red for undefined statuses
    }
  };

  const getTableData = async (page = 1, filters) => {
    try {
      const response = await apiClient.get(
        `${TRANSACTIONS_API}/gettrans/${userData.email}`,
        {
          params: {
            page,
            limit: 10,
            ...filters,
            projectId: filters.projectId
              ? filters.projectId
              : userData.projectId,
          },
        }
      );
      // console.log(response.data);

      setTotalPages(response.data.totalPages);

      return response.data;
    } catch (error) {
      // console.error("Error Fetching Table Data", error);
      throw error;
    }
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["transactions", page, filters],
    queryFn: () => getTableData(page, filters),
    keepPreviousData: true,
  });

  const handleStatusClick = async (transaction) => {
    try {
      const response = await apiClient.get(
        `${STATUS_API}/getstatus/${transaction.trans_id}`
      );
      setStatusData(response.data.data);
    } catch (error) {
      console.error("Error fetching popup data:", error);
      setStatusData([]);
    }
    setOpenstatusPopup(true);
  };

  const handleApplyFilters = (appliedFilters) => {
    setFilters({
      ...appliedFilters,
    });
    setPage(1);
    setOpenDrawer(false);
  };

  const handleCancelFilters = () => {
    const defaultFilters = {
      senderName: null,
      status: null,
      fromDate: null,
      toDate: null,
      transId: null,
      projectId: null,
      payment_type: null,
      vendorname: null,
    };
    setFilters(defaultFilters);
    setPage(1);
    setOpenDrawer(false);
  };

  const handlePageChange = (direction) => {
    if (direction === "next") setPage((prev) => prev + 1);
    if (direction === "prev" && page > 1) setPage((prev) => prev - 1);
  };

  const handleOpenPopup = (rowData) => {
    setSelectedData(rowData);
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setOpenstatusPopup(false);
    setSelectedData(null);
    setStatusData([]);
  };

  const handleFormOpen = (data) => {
    if (!data || data.nativeEvent) {
      setEditedData(null);
    } else {
      setEditedData(data);
    }
    setOpenForm(true);
  };

  const handleFormClose = () => {
    setOpenForm(false);
  };

  const handlePdfDownload = async (transId, projectId) => {
    try {
      const payload = { projectId, transId: [transId] };
      toast.info("Generating PDF...");

      const response = await apiClient.post(
        `${process.env.REACT_APP_PDF_API}/download`,
        payload
      );
      const { pdf, failedTransactionIDs } = response.data;

      if (!pdf) {
        if (failedTransactionIDs && failedTransactionIDs.length > 0) {
          alert(
            "The following transaction IDs have missing required fields:\n\n" +
            failedTransactionIDs.join("\n")
          );
        } else {
          alert("Some fields are missing.");
        }
        return;
      }

      // Convert base64 to blob and download
      const byteCharacters = atob(pdf);
      const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "transaction_report.pdf";
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Download failed.");
    }
  };

  return (
    <Container maxWidth="xl" className={style.container}>
      {isLoading && <Loader />}
      {isError && <p>Error: {error.message}</p>}
      {!isLoading && !isError && (
        <>
          <div className={style.header}>
            {/* Desktop View */}
            <div className={style.buttonGroupDesktop}>
              <div className={style.leftButtonGroup}>
                <Tooltip title="Create a new payment request" arrow>
                  <Button
                    variant="contained"
                    className={style.actionButton}
                    onClick={handleFormOpen}
                  >
                    Payment Request
                  </Button>
                </Tooltip>
                <Tooltip title="Open filter options" arrow>
                  <Button
                    variant="contained"
                    className={style.actionButton}
                    onClick={() => setOpenDrawer(true)}
                  >
                    Filters
                  </Button>
                </Tooltip>
              </div>
              <div className={style.rightButtonGroup}>
                <Tooltip title="Go to the previous page" arrow>
                  <Button
                    variant="contained"
                    className={style.paginationButton}
                    onClick={() => handlePageChange("prev")}
                    disabled={page === 1}
                  >
                    Previous
                  </Button>
                </Tooltip>
                <Tooltip title="Go to the next page" arrow>
                  <Button
                    variant="contained"
                    className={style.paginationButton}
                    onClick={() => handlePageChange("next")}
                    disabled={page === totalpages}
                  >
                    Next
                  </Button>
                </Tooltip>
              </div>
            </div>
            {/* Mobile View */}
            <div className={style.buttonGroupMobile}>
              <div className={style.mobileButtonRow}>
                <Button
                  variant="contained"
                  className={style.mobileActionButton}
                  onClick={handleFormOpen}
                >
                  <span className={style.buttonTextWrapper}>
                    <span>Payment</span>
                    <span>Request</span>
                  </span>
                </Button>
                {/* <Button
                  variant="contained"
                  className={style.mobileActionButton}
                  onClick={() => setOpenFilterModal(true)}
                >
                  <span className={style.buttonTextWrapper}>
                    <span>Download</span>
                    <span>Bank Details</span>
                  </span>
                </Button> */}
              </div>
              <div className={style.mobileButtonRow}>
                <Button
                  variant="contained"
                  className={style.mobileFilterButton}
                  onClick={() => setOpenDrawer(true)}
                >
                  Filters
                </Button>
                <div className={style.mobilePaginationGroup}>
                  <Button
                    variant="contained"
                    className={style.mobilePaginationButton}
                    onClick={() => handlePageChange("prev")}
                    disabled={page === 1}
                  >
                    Previous
                  </Button>
                  <Button
                    variant="contained"
                    className={style.mobilePaginationButton}
                    onClick={() => handlePageChange("next")}
                    disabled={page === totalpages}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className={style.tableWrapper}>
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>S.NO</TableCell>
                    <TableCell>Project ID</TableCell>
                    <TableCell>Payment Type</TableCell>
                    <TableCell>Invoice Type</TableCell>
                    <TableCell>Sender Name</TableCell>
                    <TableCell>Vendor Name</TableCell>
                    <TableCell>PO number</TableCell>
                    <TableCell>Net Payble</TableCell>
                    <TableCell>Pending Amount</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Remarks</TableCell>
                    <TableCell>Approval Stages</TableCell>
                    <TableCell>Actions</TableCell>
                    <TableCell>Download</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.transactions?.map((transaction, index) => (
                    <TableRow key={transaction.trans_id}>
                      <TableCell>
                        <Tooltip title={(page - 1) * 10 + index + 1} arrow>
                          <span>{(page - 1) * 10 + index + 1}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={transaction?.project_id || "N/A"} arrow>
                          <span>
                            {transaction?.project_id?.length > 100
                              ? `${transaction.project_id.slice(0, 100)}...`
                              : transaction?.project_id || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={transaction?.payment_type || "N/A"}
                          arrow
                        >
                          <span>
                            {transaction?.payment_type?.length > 100
                              ? `${transaction.payment_type.slice(0, 100)}...`
                              : transaction?.payment_type || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={transaction?.invoice_type || "N/A"}
                          arrow
                        >
                          <span>
                            {transaction?.invoice_type?.length > 100
                              ? `${transaction.invoice_type.slice(0, 100)}...`
                              : transaction?.invoice_type || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={transaction?.sender_name || "N/A"}
                          arrow
                        >
                          <span>
                            {transaction?.sender_name?.length > 100
                              ? `${transaction.sender_name.slice(0, 100)}...`
                              : transaction?.sender_name || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={transaction?.vendorname || "N/A"} arrow>
                          <span>
                            {transaction?.vendorname?.length > 100
                              ? `${transaction.vendorname.slice(0, 100)}...`
                              : transaction?.vendorname || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={transaction?.ponumber || "N/A"} arrow>
                          <span>
                            {transaction?.ponumber?.length > 100
                              ? `${transaction.ponumber.slice(0, 100)}...`
                              : transaction?.ponumber || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={
                            transaction
                              ? String(calculateNetPayable(transaction))
                              : "N/A"
                          }
                          arrow
                        >
                          <span>
                            {transaction
                              ? (() => {
                                  const value = String(
                                    calculateNetPayable(transaction)
                                  );
                                  return value.length > 100
                                    ? `${value.slice(0, 100)}...`
                                    : value;
                                })()
                              : "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={
                            transaction
                              ? String(getPendingAmount(transaction))
                              : "N/A"
                          }
                          arrow
                        >
                          <span>
                            {transaction
                              ? (() => {
                                const value = String(getPendingAmount(transaction));
                                return value.length > 100 ? `${value.slice(0, 100)}...` : value;
                              })()
                              : "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Tooltip title={transaction?.status || "N/A"} arrow>
                          <Chip
                            label={
                              transaction.status?.length > 100
                                ? `${transaction.status.slice(0, 100)}...`
                                : transaction.status || "N/A"
                            }
                            style={{
                              backgroundColor: getStatusColor(
                                transaction.status || "N/A"
                              ).bg,
                              color: getStatusColor(transaction.status || "N/A")
                                .text,
                            }}
                          />
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={formatDate(transaction?.createdAt) || "N/A"}
                          arrow
                        >
                          <span>
                            {formatDate(transaction?.createdAt)?.length > 100
                              ? `${formatDate(transaction?.createdAt).slice(
                                0,
                                100
                              )}...`
                              : formatDate(transaction?.createdAt) || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={transaction?.pr_remarks || "N/A"} arrow>
                          <span>
                            {transaction?.pr_remarks?.length > 100
                              ? `${transaction.pr_remarks.slice(0, 100)}...`
                              : transaction?.pr_remarks || "N/A"}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <Tooltip title="Click to view details" arrow>
                          <IconButton>
                            <StorageIcon
                              onClick={() => handleStatusClick(transaction)}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View Details" arrow>
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenPopup(transaction)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit Row" arrow>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              if (
                                ((transaction.status === statusDef.initial ||
                                  transaction.status === statusDef.fail ||
                                  transaction.status ===
                                  statusDef.financialDenied ||
                                  transaction.status ===
                                  statusDef.accountantDenied) &&
                                  transaction.sender_id === userData.email) ||
                                (role.roles_3 === userData.role &&
                                  transaction.status === statusDef.phase1) ||
                                (transaction.status === statusDef.phase1 &&
                                  userData.role === role.roles_5) ||
                                ((transaction.status === statusDef.phase4 ||
                                  transaction.status === statusDef.phase5) &&
                                  (userData.role === role.roles_3 ||
                                    userData.role === role.roles_4 ||
                                    userData.role === role.roles_5)) ||
                                (userData.role === role.roles_4 &&
                                  [
                                    statusDef.phase2,
                                    statusDef.phase3,
                                    statusDef.phase4,
                                    statusDef.phase5,
                                  ].includes(transaction.status)) ||
                                (userData.role === role.roles_5 &&
                                  [
                                    statusDef.phase2,
                                    statusDef.phase3,
                                    statusDef.phase4,
                                    statusDef.phase5,
                                  ].includes(transaction.status)) ||
                                (userData.role === role.roles_3 &&
                                  [
                                    statusDef.phase2,
                                    statusDef.phase3,
                                    statusDef.phase4,
                                    statusDef.phase5,
                                  ].includes(transaction.status))
                              ) {
                                handleFormOpen(transaction);
                              } else {
                                alert("You cannot  edit this row");
                              }
                            }}
                            style={{
                              color:
                                ((transaction.status === statusDef.initial ||
                                  transaction.status === statusDef.fail ||
                                  transaction.status ===
                                  statusDef.financialDenied ||
                                  transaction.status ===
                                  statusDef.accountantDenied) &&
                                  transaction.sender_id === userData.email) ||
                                  (role.roles_3 === userData.role &&
                                    transaction.status === statusDef.phase1) ||
                                  (transaction.status === statusDef.phase1 &&
                                    userData.role === role.roles_5) ||
                                  ((transaction.status === statusDef.phase4 ||
                                    transaction.status === statusDef.phase5) &&
                                    (userData.role === role.roles_3 ||
                                      userData.role === role.roles_4 ||
                                      userData.role === role.roles_5)) ||
                                  (userData.role === role.roles_4 &&
                                    [
                                      statusDef.phase2,
                                      statusDef.phase3,
                                      statusDef.phase4,
                                      statusDef.phase5,
                                    ].includes(transaction.status)) ||
                                  (userData.role === role.roles_5 &&
                                    [
                                      statusDef.phase2,
                                      statusDef.phase3,
                                      statusDef.phase4,
                                      statusDef.phase5,
                                    ].includes(transaction.status)) ||
                                  (userData.role === role.roles_3 &&
                                    [
                                      statusDef.phase2,
                                      statusDef.phase3,
                                      statusDef.phase4,
                                      statusDef.phase5,
                                    ].includes(transaction.status))
                                  ? "red"
                                  : "grey",
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Download" arrow>
                          <DownloadIcon
                            color="primary"
                            onClick={() => {
                              if (
                                transaction.status === statusDef.phase4 ||
                                transaction.status === statusDef.phase5 ||
                                transaction.status === statusDef.final
                              ) {
                                handlePdfDownload(
                                  transaction.trans_id,
                                  transaction.project_id
                                );
                              } else {
                                alert("You cannot Download Now");
                              }
                            }}
                            style={{
                              color:
                                transaction.status === statusDef.phase4 ||
                                  transaction.status === statusDef.phase5 ||
                                  transaction.status === statusDef.final
                                  ? "blue"
                                  : "grey",
                            }}
                          >
                            <VisibilityIcon />
                          </DownloadIcon>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <TransactionsFilter
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
            onApply={handleApplyFilters}
            onReset={handleCancelFilters}
            statusDef={statusDef}
            home_filters={filters}
          />
          <PopupCard
            key={selectedData?.trans_id}
            open={openPopup}
            onClose={handleClosePopup}
            data={selectedData}
            userData={userData}
          />
          <ModalForm
            initialFormData={editedData}
            open={openForm}
            handleClose={handleFormClose}
          />
          <Statuscard
            open={openstatusPopup}
            onClose={handleClosePopup}
            data={statusdata}
            userData={userData}
          />
        </>
      )}
    </Container>
  );
}

export default TransactionsTable;
